import { Injectable, OnDestroy } from '@angular/core';
import { ActiveMaintenanceNoticeDTO } from '@chicilon/angular-user-service';
import { EMPTY, Observable, Subject } from 'rxjs';

export type MaintenanceBroadcastMessage =
  | { type: 'notice'; notice: ActiveMaintenanceNoticeDTO | null }
  | { type: 'dismissed' }
  | { type: 'dismiss-cleared' };

@Injectable({ providedIn: 'root' })
export class MaintenanceBroadcastService implements OnDestroy {
  private readonly CHANNEL_NAME = 'chicilon_maintenance';
  private readonly channel = typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel(this.CHANNEL_NAME) : null;
  private readonly messagesSubject = new Subject<MaintenanceBroadcastMessage>();

  // Other tabs only (BroadcastChannel never echoes the sender); EMPTY when the API is unavailable.
  readonly messages$: Observable<MaintenanceBroadcastMessage> = this.channel ? this.messagesSubject.asObservable() : EMPTY;

  constructor() {
    if (this.channel) {
      this.channel.onmessage = event => this.messagesSubject.next(event.data as MaintenanceBroadcastMessage);
    }
  }

  post(message: MaintenanceBroadcastMessage): void {
    this.channel?.postMessage(message);
  }

  ngOnDestroy(): void {
    this.channel?.close();
    this.messagesSubject.complete();
  }
}
